export default __webpack_public_path__ + "static/media/985.e8c10f99.gif";